/*
 Version: v4.2.0
 Deprecated: No longer tested, documented, or maintained.
 Apache License 2.0: Copyright (c) 2010-2018 LiosK
*/
const UUID = function() {};
UUID.generate = function() {
  var b = UUID._getRandomInt,
    c = UUID._hexAligner;
  return c(b(32), 8) + '_' + c(b(16), 4) + '_' + c(16384 | b(12), 4) + '_' + c(32768 | b(14), 4) + '_' + c(b(48), 12);
};
UUID._getRandomInt = function(b) {
  if (0 > b || 53 < b) return NaN;
  var c = 0 | (1073741824 * Math.random());
  return 30 < b ? c + 1073741824 * (0 | (Math.random() * (1 << (b - 30)))) : c >>> (30 - b);
};
UUID._hexAligner = function(b, c) {
  for (var a = b.toString(16), d = c - a.length, e = '0'; 0 < d; d >>>= 1, e += e) d & 1 && (a = e + a);
  return a;
};
UUID.overwrittenUUID = UUID;

export default UUID;
